export const ListUsers = [
  {
    user: 'sabri',
    password: '123',
  },
  {
    user: 'softys',
    password: 'expodireto2026',
  },
  {
    user: 'totem1',
    password: 'softys26',
  },
  {
    user: 'totem2',
    password: 'softys26',
  },
  {
    user: 'totem3',
    password: 'softys26',
  },
]